export type Notification = {
  message: string;
  type: NotificationType;
  removeAnimation?: boolean;
};

export enum NotificationType {
  Success = "Success",
  Error = "Error",
  Info = "Info",
  Warning = "Warning"
}
